export const nbsp = '\xa0';

export const titleFormatter = (title) => title.toLowerCase().replace(/(\s[A-zА-яЁё]{1,2})\s/g, `$1${nbsp}`);

